module.exports = __webpack_public_path__ + "img/sucess.f0643670.svg";